import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ViewApiService } from '@wdx/clmi/api-services/services';

import {
    integerMaskNumberConfigOverride,
    TranslationsService,
    View,
} from '@wdx/shared/utils';
import { Observable } from 'rxjs';
import { WorkflowNode } from '../../../models';
import {
    encodedStringDeserialiser,
    passthroughOutputHandler,
} from '@wdx/shared/components/wdx-json-editor';

@Component({
    selector: 'clmi-workflow-designer-parameter-query',
    templateUrl: './parameter-query.component.html',
    standalone: false,
})
export class WorkflowDesignerParameterQueryComponent implements OnInit {
    private readonly viewApiService = inject(ViewApiService);
    private readonly translationsService = inject(TranslationsService);

    @Input() node: WorkflowNode;
    @Input() formGroup: FormGroup;

    readonly customInputHandler = encodedStringDeserialiser;
    readonly customOutputHandler = passthroughOutputHandler;
    readonly integerMaskNumberConfigOverride = integerMaskNumberConfigOverride;

    public views$: Observable<View[]>;

    get viewCodeControl() {
        return this.formGroup.get('viewCode') as FormControl;
    }

    get queryControl() {
        return this.formGroup.get('query') as FormControl;
    }

    get descriptionControl() {
        return this.formGroup.get('queryDescription') as FormControl;
    }

    get exclusionPeriodControl() {
        return this.formGroup.get('exclusionPeriod') as FormControl;
    }

    ngOnInit(): void {
        this.initialiseViews();
        this.initialiseJsonEditor();
        this.formGroup.addControl(
            'queryDescription',
            new FormControl(this.node.payload.queryDescription),
        );
        this.formGroup.addControl(
            'exclusionPeriod',
            new FormControl(
                this.node.payload.exclusionPeriod ??
                    this.node.payload.exclutionPeriod,
            ),
        );
    }

    private initialiseViews() {
        this.formGroup.addControl('viewCode', new FormControl(null));

        const targetEntityType = this.node.targetEntityType;
        if (!targetEntityType) {
            return;
        }
        this.views$ = this.viewApiService.getForEntity(targetEntityType);
    }

    private initialiseJsonEditor() {
        const queryJson = JSON.stringify(this.node.payload.query ?? null);
        const queryControl = new FormControl(queryJson, [Validators.required]);
        this.formGroup.addControl('query', queryControl);
    }

    onViewCodeChanged(view: View | null) {
        if (!view) {
            return;
        }
        this.descriptionControl.setValue(
            this.translationsService.translateTokenisedString(view.name),
        );
        this.queryControl.setValue(JSON.stringify(view.filter));
    }
}
